// Libraries
require("./libs/product");

// Partials
require("./partials/criteo/_productPage");
require("./partials/criteo/_criteoCarousel");
import "./partials/criteo/_criteoConsentCheck";
require("./partials/common/_owlCarousel");
require("./partials/product/_productImage");
require("./partials/product/_backInStock");
//require ('./partials/product/_socialSharing');
require("./partials/product/_attributes.js");
//require ('./partials/product/_cross-sell');
require("./partials/product/_imagesGallery");
require("./partials/product/_productNavigation");
require("./partials/product/_breadcrumbs");
require("./partials/product/_shopPay");
require("./partials/product/_stockAlert");
require("./partials/product/_variants");
require("./partials/product/_discountBadges");
require("./partials/product/_productChargerTag");
require("./partials/product/_productLoadbee");

// Modules
require("./modules/financing-simulator");
